import React from 'react'
import { DevFullStackBarStyles } from '../styles/devFullStackBarStyles'

function DevFullStackBar() {

  return (
    <DevFullStackBarStyles>
        <h4>Dev-FullStack</h4>
    </DevFullStackBarStyles>
  )
}

export default DevFullStackBar